import React, { Fragment } from 'react';

const TextField = (props) => {
    const changeHandler = (event) => {
        let value = event.target.value.replace(/ +(?= )/g, '');

        if (props.limit && value.length > props.limit) {
            return;
        }

        props.setFunction(value);
    };

    const phoneChangeHandler = (event) => {
        let phone = event.target.value.replace(/ +(?= )/g, '');
        phone = phone.replace(/[A-Za-z_]/g, '');
        phone = phone.replace(/[.()\- ]/g, '');

        if (props.phoneFormat && props.phoneFormat === 2) {
            if (phone.length > 6) {
                phone = ['(', phone.slice(0, 3), ') ', phone.slice(3)].join('');
                phone = [phone.slice(0, 9), '-', phone.slice(9)].join('');
            } else if (phone.length > 3) {
                phone = ['(', phone.slice(0, 3), ') ', phone.slice(3)].join('');
            }
        } else if (props.phoneFormat && props.phoneFormat === 3) {
            if (phone.length > 6) {
                phone = [phone.slice(0, 3), '-', phone.slice(3)].join('');
                phone = [phone.slice(0, 7), '-', phone.slice(7)].join('');
            } else if (phone.length > 3) {
                phone = [phone.slice(0, 3), '-', phone.slice(3)].join('');
            }
        } else {
            if (phone.length > 6) {
                phone = [phone.slice(0, 3), '.', phone.slice(3)].join('');
                phone = [phone.slice(0, 7), '.', phone.slice(7)].join('');
            } else if (phone.length > 3) {
                phone = [phone.slice(0, 3), '.', phone.slice(3)].join('');
            }
        }

        props.setFunction(phone);
    };

    const websiteChangeHandler = (event) => {
        let website = event.target.value.replace(/^(http:\/\/)|(https:\/\/)/g, '');

        if (props.limit && website.length > props.limit) {
            return;
        }

        props.setFunction(website);
    };

    const blurHandler = (event) => {
        let value = event.target.value.trim();
        props.setFunction(value);
    };

    let onChangeHandler = changeHandler;
    let onBlurHandler = blurHandler;
    if (props.isPhone) {
        onChangeHandler = phoneChangeHandler;
        onBlurHandler = null;
    } else if (props.isWebsite) {
        onChangeHandler = websiteChangeHandler;
        onBlurHandler = null;
    }

    const requiredHtml = props.required ? <Fragment> <span className="required">*</span></Fragment> : null;
    return (
        <div className="variable">
            <div className="label">{props.label}{requiredHtml}:</div>
            <input
                type="text"
                value={props.value}
                onChange={onChangeHandler}
                onBlur={onBlurHandler}
                placeholder={props.placeholder ? props.placeholder : props.label}
                disabled={props.disabled}
            />
        </div>
    );
}

export default TextField;